/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import cx from 'classnames';
import React, {
  FC, useCallback, useEffect, useRef, useState,
} from 'react';

import { IListItem } from '@/contentful/utils/listItem';

import IconShevron from './assets/icon-shevron-accordion.svg';

import styles from './part-accordion-item.module.scss';

interface IAccordionItemProps {
  element: IListItem;
  index: number;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

const AccordionItem: FC<IAccordionItemProps> = ({
  element,
  index,
  activeIndex,
  setActiveIndex,
}) => {
  const [active, setActive] = useState(index === activeIndex);
  const contentRef = useRef<HTMLDivElement>(null);

  const accordionItemHandler = useCallback(
    (idx: number) => (idx === activeIndex ? setActive(true) : setActive(false)),
    [activeIndex],
  );

  useEffect(() => {
    accordionItemHandler(index);
  }, [index, accordionItemHandler]);

  const handleClick = () => {
    setActive((prevState) => !prevState);
    setActiveIndex(index);
  };

  return (
    <li className={cx(styles.accordionItem, { [styles.accordionItemActive]: active })}>
      <div className={styles.title} onClick={handleClick}>
        <p>{element.title}</p>
        <span className={cx(styles.icon, { [styles.iconActive]: active })}>
          <IconShevron />
        </span>
      </div>
      <div
        className={styles.content}
        ref={contentRef}
        style={{
          maxHeight: active ? `${contentRef.current && contentRef.current.scrollHeight}px` : '0px',
        }}
      >
        <div className={styles.contentInner}>{element.content}</div>
      </div>
    </li>
  );
};

export default AccordionItem;
